module.exports = __webpack_public_path__ + "img/news-banner.a0d7cd01.jpg";